import { mapGetters } from "vuex";
import { isEmpty, isNil } from "lodash-es";

import BILLABLE_TYPE from "@Constants/billable-type";
import SUBSCRIPTION_TYPE from "@Constants/subscription-type";

export default {
  computed: {
    ...mapGetters([
      "organizationTeam",
      "organization",
      "user",
      "isUserLoggedIn",
      "getUserCurrentSubscription",
    ]),

    billable() {
      switch (this.billableType) {
        case BILLABLE_TYPE.USER: return this.getBillableUser();
        case BILLABLE_TYPE.TEAM: return this.getBillableTeam();
        case BILLABLE_TYPE.ORGANIZATION: return this.getBillableOrganization();
        default: throw new Error("Unsupported billable type");
      }
    },

    billableType() {
      const fullPath = this.$route?.fullPath;
      const inOrganization = fullPath.includes("/organizations/");
      const inTeam = inOrganization && fullPath.includes("/team/");

      if (inTeam) return BILLABLE_TYPE.TEAM;
      else if (inOrganization) return BILLABLE_TYPE.ORGANIZATION;
      else return BILLABLE_TYPE.USER;
    },

    billingUser() {
      return this.billableType && this.billableType === BILLABLE_TYPE.USER;
    },

    billingTeam() {
      return this.billableType && this.billableType === BILLABLE_TYPE.TEAM;
    },

    billingOrganization() {
      return (
        this.billableType && this.billableType === BILLABLE_TYPE.ORGANIZATION
      );
    },

    billableHasPaymentMethod() {
      return (
        this.billable.pm_country !== null &&
        this.billable.pm_expiration !== null &&
        this.billable.pm_last_four !== null &&
        this.billable.pm_type !== null
      );
    },
  },

  methods: {
    getUserPaymentMethod() {
      const billingCollection = this.user?.billing_customers;

      if (isNil(billingCollection) || isEmpty(billingCollection)) {
        return {};
      }

      const paymentMethod = billingCollection[0];

      return {
        pm_type: paymentMethod.pm_type,
        pm_last_four: paymentMethod.pm_last_four,
        pm_expiration: paymentMethod.pm_expiration,
        pm_country: paymentMethod.pm_country,
      };
    },

    getUserSubscriptions() {
      if (!this.isUserLoggedIn) {
        return {};
      }

      let currentSubscriptions = this.user?.subscriptions?.current;
      currentSubscriptions = currentSubscriptions?.filter((d) => {
        return d.type === SUBSCRIPTION_TYPE.DEFAULT;
      });

      return {
        currentSubscription: currentSubscriptions?.[0] ?? null,
      };
    },

    getBillableUser() {
      return {
        ...this.user,
        ...this.getUserPaymentMethod(),
        ...this.getUserSubscriptions(),
      };
    },

    getBillableTeam() {
      return {
        ...this.organizationTeam,
        currentSubscription: {},
      };
    },

    getBillableOrganization() {
      return {
        ...this.organization,
        currentSubscription: {},
      };
    },
  },
};
